import initializeSvelteApp from "common/initializeSvelteApp";
import component from "./App";

initializeSvelteApp({
  component,
  target: ".js-subscription-modal",
  props: element => {
    return {
      url: element.getAttribute("data-url"),
      strings: JSON.parse(element.getAttribute("data-strings"))
    };
  }
});
